/**
 * Shared DotLottie preloader graphic (single size everywhere — see {@link SAAE_PRELOADER_BOX_CLASS}).
 */

import clsx from 'clsx';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { SAAE_PRELOADER_BOX_CLASS, SAAE_PRELOADER_DOTLOTTIE_URL } from '@lib/saaePreloader';

export function SaaePreloaderCore({ className }: { className?: string }) {
  return (
    <div
      className={clsx(
        'flex shrink-0 items-center justify-center',
        SAAE_PRELOADER_BOX_CLASS,
        className,
      )}
      dir="ltr"
    >
      <div className="saee-lottie-host h-full w-full max-h-full max-w-full">
        <DotLottieReact
          src={SAAE_PRELOADER_DOTLOTTIE_URL}
          loop
          autoplay
          renderConfig={{ autoResize: true }}
          className="block h-full w-full max-h-full max-w-full object-contain"
        />
      </div>
    </div>
  );
}
